import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

/**
 * Label + value pair shared across the detail card and the print
 * layout. Both views renders the same data fields ("Employee",
 * "Department", etc.); keeping a single component prevents drift
 * (e.g. the recent date-format change had to land in two files).
 */
export interface SuggestionFieldProps {
  label: string;
  value: ReactNode;
  /**
   * "compact" — the version used inside the on-screen Submission
   * Details card (small label, body1 value, weight 500).
   * "print" — the version used in SuggestionPrint (caption label,
   * body1 value, slight top margin). Print stays B&W-friendly.
   */
  variant?: "compact" | "print";
}

export default function SuggestionField({
  label,
  value,
  variant = "compact",
}: SuggestionFieldProps) {
  if (variant === "print") {
    return (
      <Box>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.25 }}>
          {value ?? "—"}
        </Typography>
      </Box>
    );
  }
  return (
    <Box>
      <Typography
        sx={{ fontSize: 12, color: "text.secondary", lineHeight: 1.4 }}
      >
        {label}
      </Typography>
      <Typography variant="body1">{value ?? "—"}</Typography>
    </Box>
  );
}
